
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"d":"M13.16 5.553l-3.627-4a.667.667 0 00-.493-.22H4.373A1.687 1.687 0 002.667 3v10a1.687 1.687 0 001.706 1.667h7.254A1.687 1.687 0 0013.333 13V6a.667.667 0 00-.173-.447zM11.767 6H9.14a.527.527 0 01-.473-.567V2.667h.073L11.767 6zm-.14 7.333H4.373A.353.353 0 014 13V3a.353.353 0 01.373-.333h2.96v2.766a1.86 1.86 0 001.807 1.9H12V13a.353.353 0 01-.373.333z"}})])
          )
        }
      }
    